module.exports = __webpack_public_path__ + "img/main_warasibe.6057e4de.png";